import React from 'react'
import {connect} from 'react-redux';
import moment from 'moment';
import BigCalendar from 'react-big-calendar';
import {DashboardCalendarTasksModal} from '../';

import * as Actions from 'actions';

class DashboardCalendar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			show_event_modal : false,
			current_event : {}
		}

		this.handleHide = this.handleHide.bind(this);
		this.handleSelectEvent = this.handleSelectEvent.bind(this);
	}

	handleSelectEvent(e) {
		this.setState({current_event : e},
			() =>{this.setState({show_event_modal : true})}
		);
	}

	handleHide() {
		this.setState({show_event_modal : false})
		this.setState({current_event : {}})
	}

	componentWillMount() {
		this.props.beginInitUsersTasks()
		BigCalendar.momentLocalizer(moment);
	}

	render() {
		let tasks = this.props.tasks.tasks.filter(({due_date}) => due_date).map(task => {
			return {
				title : task.text,
				start : moment((task.due_date || '').slice(0,10), 'YYYY-MM-DD').toDate(),
				end : moment((task.due_date || '').slice(0,10), 'YYYY-MM-DD').toDate(),
				_id : task._id
			}
		})
		return (
			<div className='dashboard-calendar-container animated fadeInRight' >
				<DashboardCalendarTasksModal
					show_event_modal={this.state.show_event_modal}
					onHide={this.handleHide}
					current_event={this.state.current_event}

					/>
				<div className='panel'>
					<div className='panel-heading'>
						<h4 className='panel-title'>
							Tasks Calendar
						</h4>
					</div>
					<div className='panel-body clearfix'>
						<BigCalendar
              style={{minHeight: '560px'}}
							events={tasks}
							defaultDate={new Date()}
							timeslots={2}
							popup
							selectable
							onSelectEvent={this.handleSelectEvent}
							views={['month']}
						/>
					</div>
				</div>
			</div>
			)
	}
}

let mapStateToProps = ({tasks}) => ({tasks})

export default connect(mapStateToProps, Actions)(DashboardCalendar)



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/dashboardCalendar.js